export const BUSINESS_CARD_ID = 6
export const EXPORT_XLSX_ID = 7
export const PATH_CARD = [{
    value: 1,
    name: '詳細指定読取'
}, {
    value: 2,
    name: '配置再現読取'
}, {
    value: 3,
    name: '名刺OCR'
}]
export const PATH_TEMPLATE = '/templates'
export const PATH_EXPORT_XLSX = '/export_xlsx'
export const PATH_BUSINESS_CARD = '/business_card'
export const TITLE = '項目目'
export const RESULT = '項目情報'
export const WIDTH_DEVICE = 820
export const READ = "read";
export const ALL = "all";
